define('app/views/templates/helpers/formatContactLogs',['Handlebars'], function ( Handlebars, _ ){
  function formatContactLogs(text) {
    text = Handlebars.Utils.escapeExpression(text);
    text = text.replace(/(%0A)/gm, '\r\n');
    text = text.replace(/(%20)/gm, ' ');
    return new Handlebars.SafeString(text);     
  }

  Handlebars.registerHelper( 'formatContactLogs', formatContactLogs );
  return formatContactLogs;
});
